import { WebappSdkLogger } from '@/types/webapp-sdk';
import { getRootDeputyFrame } from '@/global-libs/deputy-embed';
import getConfig from '@config';

import { DDLogger, DDLoggerConfiguration } from '../app';

let _initialized = false;
const { WEBAPP_ENV } = getConfig();

function checkInitialized(): void {
  if (!_initialized) {
    throw new Error(
      'Logger is not initialized. Call await logger.initialize() at the beginning of your app'
    );
  }
}

async function initialize(): Promise<void> {
  _initialized = true;
  return;
}

function getDDLogs() {
  const deputyWindow = getRootDeputyFrame() as Window;

  if (deputyWindow.DD_LOGS) {
    return deputyWindow.DD_LOGS;
  }

  return null;
}

function createLogger(
  name: string,
  config?: DDLoggerConfiguration
): DDLogger | undefined {
  checkInitialized();
  const ddLogs = getDDLogs();
  const logger = ddLogs?.createLogger(name, config);
  return logger;
}

function getLogger(name?: string): DDLogger | undefined {
  checkInitialized();
  const ddLogs = getDDLogs();

  if (ddLogs) {
    return name ? ddLogs.getLogger(name) : ddLogs.logger;
  } else if (WEBAPP_ENV === 'local') {
    console.log('Logger is replaced with console.log locally');
    return;
  }
  console.error('Datadog logger not found');
}

export function logInfo(message: string, params: unknown): void {
  const logger = getLogger();

  if (logger && WEBAPP_ENV !== 'local') {
    logger.info(message, params);
  } else {
    console.group('Logger info');
    console.log(message, params);
    console.groupEnd();
  }
}

export function logError(
  message: string,
  params: unknown,
  error: unknown
): void {
  const logger = getLogger();

  if (logger && WEBAPP_ENV !== 'local') {
    logger.error(message, params, error);
  } else {
    console.error(message, params, error);
  }
}

export default function loggerSdk(): WebappSdkLogger {
  return {
    initialize,
    createLogger,
    getLogger,
    logInfo,
    logError,
  };
}
